import { createContext, useReducer } from 'react';

import { ActionKind, IState } from './actions';
import { fermentationActionReducer, initialState } from './reducer';

export const FermentationActionContext = createContext(
  {} as {
    state: IState;
    resetModals: () => void;
    resetOperation: () => void;
    openRemoveModal: (id: string) => void;
    openCompleteModal: (id: string) => void;
    openAddBatchModal: (id: string) => void;
  },
);

export function ProvideFermentationAction({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer(fermentationActionReducer, initialState);

  const resetModals = () => {
    dispatch({ type: ActionKind.ResetFermentationActionState });
  };

  const openRemoveModal = (id: string) => {
    dispatch({ type: ActionKind.OpenFermentationRemoveModal, id });
  };

  const openCompleteModal = (id: string) => {
    dispatch({ type: ActionKind.OpenFermentationCompleteModal, id });
  };

  const openAddBatchModal = (id: string) => {
    dispatch({ type: ActionKind.OpenAddBatchIntoFermentationModal, id });
  };

  const resetOperation = () => {
    dispatch({ type: ActionKind.ResetFermentationOperation });
  };

  return (
    <FermentationActionContext.Provider
      value={{
        resetModals,
        openRemoveModal,
        openCompleteModal,
        openAddBatchModal,
        resetOperation,
        state,
      }}
    >
      {children}
    </FermentationActionContext.Provider>
  );
}
